import styled from 'styled-components';
import { useListenerData } from './Three.hooks';

export function CameraInfo() {
  const data = useListenerData('cameraPos');

  function toClipboard() {
    navigator.clipboard.writeText(JSON.stringify(data));
  }

  return (
    <Wrapper onClick={toClipboard}>
      <Header>CAM</Header>
      <div title='radius'>{data.radius}</div>
      <div title='α'>{data.alpha}</div>
      <div title='beta'>{data.beta}</div>
    </Wrapper>
  );
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2px 10px;
  font-family: monospace;
  cursor: pointer;
  position: absolute;
  bottom: 5px;
  color: pink;
  right: 40px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);

  div {
    flex: 1;
    text-align: center;

    &:first-child {
      max-width: 35px;
    }
  }

  &:hover {
    color: #eee;
  }
`;

export const Header = styled.div`
  color: #ffc0cb92;
`;
